class TeamEditController {
  constructor(
    TeamsFactory,
    MiscFactory,
    $rootScope,
    $filter,
    $state,
    $stateParams,
    ngDialog,
    URLS
  ) {
    "ngInject";
    const vm = this;

    let $date = $filter("date");

    vm.teamId = $stateParams.id;
    vm.rootScope = $rootScope;

    vm.$onInit = () => {
      vm.team = {};
      vm.regions = [];
      MiscFactory.getRegions().then((response) => {
        vm.regions = response.data;
      });
      let defaultLat = 24.7251918;
      let defaultLng = 46.8225288;
      if (vm.teamId) {
        TeamsFactory.getOne(vm.teamId, { include: "region" }).then(
          (response) => {
            vm.team = response.data;
            if (!vm.team.lat || !vm.team.lng) {
              vm.team.lat = defaultLat;
              vm.team.lng = defaultLng;
            }
          }
        );
      } else {
        vm.team.lat = defaultLat;
        vm.team.lng = defaultLng;
      }
    };

    let dateTimePickerDefaultConfig = {
      startView: "day",
      minView: "day",
    };
    vm.datePickerConfig = Object.assign(dateTimePickerDefaultConfig, {
      dropdownSelector: "#registrationDate",
    });

    /* On marker drag end */
    vm.getCurrentLocation = (event) => {
      vm.team.lat = event.latLng.lat();
      vm.team.lng = event.latLng.lng();
    };

    vm.submit = () => {
      if (!vm.rootScope.user.isUserTypeTeam()) {
        vm.team.registration_date = $date(
          vm.team.registration_date,
          "yyyy-MM-dd"
        );
      }
      if (vm.team.team_id) {
        TeamsFactory.update(vm.team.team_id, vm.team).then((response) => {
          ngDialog.open({ template: "successTemplate" });
          $state.reload();
        });
      } else {
        TeamsFactory.create(vm.team).then((response) => {
          ngDialog.open({ template: "successTemplate" });
          $state.go("team-edit", { id: response.data.team_id });
        });
      }
    };

    vm.getTeamImage = () => {
      if (vm.team.img) {
        return URLS.IMAGES_URL + "/teams/" + vm.team.img;
      } else {
        return "assets/images/no_avatar.png";
      }
    };

    vm.goToProfile = () => {
      $state.go("team-profile", { id: vm.teamId });
    };
  }
}

export default TeamEditController;



// WEBPACK FOOTER //
// ./client/app/components/teams/teamEdit/teamEdit.controller.js